import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Link } from 'react-router-dom';
import dayjs from 'dayjs';

// MUI
import Paper from '@material-ui/core/Paper';
import MUILink from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

// icons
import LocationOn from '@material-ui/icons/LocationOn';
import LinkIcon from '@material-ui/icons/Link';
import CalendarToday from '@material-ui/icons/CalendarToday';

// redux
import { connect } from 'react-redux';
import ProfileSkeleton from '../../util/ProfileSkeleton';

const styles = theme => ({
  ...theme.profileStyle
});

export class StaticProfile extends Component {
  render() {
    const { classes, profile, loading } = this.props;

    const { imageUrl, handle, bio, website, location, createdAt } = profile;

    let profileMarkup = !loading ? (
      profile === null ? (
        <p>No profile found</p>
      ) : (
        <Paper className={classes.paper}>
          <div className={classes.profile}>
            <div className='image-wrapper'>
              <img src={imageUrl} alt='profile' className='profile-image' />
            </div>
            <hr />
            <div className='profile-details'>
              <MUILink
                component={Link}
                to={`/user/${handle}`}
                color='primary'
                variant='h5'
              >
                @{handle}
              </MUILink>
              <hr />
              {bio && <Typography variant='body2'>{bio}</Typography>}
              <hr />
              {location && (
                <Fragment>
                  <LocationOn color='primary' /> <span>{location}</span>
                  <hr />
                </Fragment>
              )}
              {website && (
                <Fragment>
                  <LinkIcon color='primary' />
                  <a href={website} target='_blank' rel='noopener noreferrer'>
                    {' '}
                    {website}
                  </a>
                  <hr />
                </Fragment>
              )}
              <CalendarToday color='primary' />{' '}
              <span>Joined {dayjs(createdAt).format('MMM YYYY')}</span>
            </div>
          </div>
        </Paper>
      )
    ) : (
      <ProfileSkeleton />
    );
    return profileMarkup;
  }
}

StaticProfile.propTypes = {
  classes: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  profile: state.data.profile,
  loading: state.data.loading
});

export default connect(mapStateToProps)(withStyles(styles)(StaticProfile));
